import * as MDICONS from '@material-ui/icons';
import React from 'react'
const initState = {
    // Please do not change the values of variable...
    admin: 0,
    employee: 1,
    outsider: 2,
    invalid: 3,

    color: {
        0: 'rgba(13, 71, 161, 0.2)',
        1: 'rgba(106, 27, 145, 0.2)',
        2: 'rgba(173, 20, 87, 0.2)',
        3: 'rgba(40, 53, 147, 0.2)',
    },
    textColor: {
        0: 'rgba(13, 71, 161, 1)',
        1: 'rgba(106, 27, 145, 1)',
        2: 'rgba(173, 20, 87, 1)',
        3: 'rgba(40, 53, 147, 1)',
    },

    text: {
        0: 'ADMIN',
        1: 'INTERNAL',
        2: 'EXTERNAL',
        3: 'UNIDENTIFIED',
    },

    textLC: {
        0: 'admin',
        1: 'employee',
        2: 'limited',
        3: 'no',
    },

    icon: {
        0: <MDICONS.SupervisedUserCircle />,
        1: <MDICONS.AccountCircle />,
        2: <MDICONS.AccountBox />,
        3: <MDICONS.Warning />,
    },

    /////////////////////////////////////////////////
    /// README: Controls

    // COMPANY
    companyRoles: [{ access: 0, title: "admin" }, { access: 1, title: "employee" }],

    isCompanyInsider: {
        0: true,
        1: true,
        2: false,
        3: false,
    },

    companyPaymentAccess: {
        0: true,
        1: false,
        2: false,
        3: false,
    },

    companyAccountPageAccess: {
        0: true,
        1: true,
        2: true,
        3: false,
    },

    companyMember: {
        0: true,
        1: true,
        2: false,
        3: false,
    },

    companyEditingRights: {
        0: true,
        1: false,
        2: false,
        3: false,
    },
    companyDashboardOnlyAccess: {
        0: true,
        1: false,
        2: false,
        3: false,
    },

    // MARKER
    markerViewingToggleAccess: {
        0: true,
        1: true,
        2: false,
        3: false,
    },

    markerAdditionAccess: {
        0: true,
        1: true,
        2: false,
        3: false,
    },

    markerEditingAccess: {
        0: true,
        1: true,
        2: false,
        3: false,
    },
    markerDeletionAccess:{
        0: true,
        1: true,
        2: false,
        3: false,
    },

    // PROJECT
    projectRolesForInternals: [{ access: 0, title: "admin" }, { access: 1, title: "employee" }],
    projectRolesForExternals: [{ access: 2, title: "limited" }],

    isProjectInsider: {
        0: true,
        1: true,
        2: false,
        3: false,
    },

    projectDashboardAccess: {
        0: true,
        1: true,
        2: true,
        3: false,
    },

    newProjectCreationAccess: {
        0: true,
        1: true,
        2: false,
        3: false,
    },

    projectAccessLevelChange: {
        0: true,
        1: false,
        2: false,
        3: false,
    },

    projectDashboardOnlyAccess: {
        0: true,
        1: false,
        2: false,
        3: false,
    },
    limitTrackerProjectDashboardAccess:{
        0:true,
        1:true,
        2:false,
        3:false
    },

    createNewFloorAccess: {
        0: true,
        1: false,
        2: false,
        3: false,
    },

    uploadNewMapAccess: {
        0: true,
        1: false,
        2: false,
        3: false,
    },

    createNewTagAccess: {
        0: true,
        1: true,
        2: false,
        3: false,
    },

    seeProjectNotificationsAccess: {
        0: true,
        1: false,
        2: false,
        3: false,
    },
}


const accessLevelReducer = (state = initState, action) => {

    return state;
}

export default accessLevelReducer;